// extracted by mini-css-extract-plugin
export default {"favourites-button":"favourites-button--NR_rf","favourites-button--active":"favourites-button--active--D6CXS","favourites-button--touch":"favourites-button--touch--nCNp2"};